import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ApiStatus, Pageable } from "services/common"

interface ActorDetailsTYpe {
  userId: string
  name: string
  emailId: string
  mobileNo: string
  dialerCode: string
}

interface AdditionalChargeType {
  [key: string]: number
}

interface PayoutType {
  id: number
  paymentAmount: number
  userId: number
}

interface HostFeesType {
  [key: string]: any
}

interface PropertyInformationType {
  propertyId: string
  propertyName: string
  unitId: string
  propertyFullAddress: string
}

interface TravelerInformationType {
  firstName: string | null
  lastName: string | null
  email: string | null
  mobileNo: string | null
  dialerCode: string
}
export interface ChangeLogType {
  bookingNo: string
  timestamp: string
  actor: string
  actorDetails: ActorDetailsTYpe
  action: string
  description: string
  bookingStatus: string
  paymentStatus: string
  feeList: any | null
  taxList: any | null
  hostPayoutAmount: number | null
  travelerPaymentAmount: number | null
  whimstayHostServiceFee: number | null
  whimstayTravelerServiceFee: number | null
  propertyInformation: PropertyInformationType | null
  payment: any | null
  paymentType: any | null
  stagePayment: any | null
  travelerAdditionalCharge: AdditionalChargeType
  hostAdditionalCharge: AdditionalChargeType
  hostPayouts: PayoutType[]
  travelerPayments: PayoutType[]
  travelerStagedPayments: PayoutType[]
  cancellationFee: number
  hostFees: HostFeesType
  checkInDate: string | null
  checkOutDate: string | null
  adultNumber: number | null
  childNumber: number | null
  petNumber: number | null
  oldAdultNumber: number | null
  oldChildNumber: number
  oldPetNumber: number
  oldCheckInDate: string | null
  oldCheckOutDate: string | null
  oldTravelerPaymentAmount: number | null
  oldPropertyInformation: PropertyInformationType | null
  oldTravelerInfo: TravelerInformationType | null
  travelerInfo: TravelerInformationType | null
  timestampMillis: number
  currentStripeChargeDueDate: number | null
  extendedStripeChargeDueDate: number | null
}

export interface ShowChangeLogDetailsResponseDataData extends Pageable {
  content: ChangeLogType[]
}

interface ShowChangeLogDetailsResponseData extends AxiosResponse {
  data: ShowChangeLogDetailsResponseDataData
  apiStatus: ApiStatus
}

interface ShowChangeLogDetailsResponse extends AxiosResponse {
  data: ShowChangeLogDetailsResponseData
}

export interface ShowChangeLogDetailsRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    bookingNumber: string | null
    keyword: string | null
    actor: string | null
    pageNo: number | null
    noOfRecords: number | null
    sortDirection: string | null
    sortBy: string | null
  }
}

export function showChangeLogDetailsApi(
  { params, ...config }: ShowChangeLogDetailsRequest,
  axiosInstance: AxiosInstance,
): Promise<ShowChangeLogDetailsResponse> {
  return axiosInstance({
    params,
    method: "get",
    url: `/admin/booking/log`,
    ...config,
  }) as Promise<ShowChangeLogDetailsResponse>
}
